import React, { Component } from "react";
import { connect } from "react-redux";

import { Table, Input, Alert } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { API_BASE } from "../../utils/contrains";
import { getSSPAcademicYear } from "../../utils/dateUtil";
import {
  req_list_ssp_target_goal,
  req_downloadfile_ssp_target_goal,
} from "../../api";

class SchoolPlanTargetGoal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    totalTarget: 1,
    totalPlan: 0,
    totalConfident: 0,
  };

  componentWillMount() {
    this.api_item_list();
  }

  //////////
  api_item_list = async () => {
    const { planAcademicYear } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_target_goal(
      userCode,
      "VIEWER",
      planAcademicYear,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      //console.log(items);
      const totalTarget = items.reduce((accumulator, object) => {
        return accumulator + object.PlanALLApprovedTotal;
      }, 0);
      const totalPlan = items.reduce((accumulator, object) => {
        return accumulator + object.PlanQuotaTotal;
      }, 0);
      const totalConfident = items.reduce((accumulator, object) => {
        return accumulator + object.ConfidentQuotaTotal;
      }, 0);
      this.setState({ data: items, totalTarget, totalPlan, totalConfident });
      // console.log(totalTarget);
    } else {
      const items = [];
      this.setState({
        data: items,
        totalTagert: 0,
        totalPlan: 0,
        totalConfident: 0,
      });
    }
  };

  api_downloadfile_items = async () => {
    const { planAcademicYear } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    // download file data
    const fileUrl = await req_downloadfile_ssp_target_goal(
      userCode,
      userLevel,
      planAcademicYear,
      "ALL",
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_downloadfile_small_items = async () => {
    const { planAcademicYear } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    // download file data
    const fileUrl = await req_downloadfile_ssp_target_goal(
      userCode,
      userLevel,
      planAcademicYear,
      "SMALL",
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  //////////
  handle_data_refresh = () => {
    //this.api_list_studentsource_noloading();
    this.api_item_list();
    console.log("refresh");
  };

  handle_show_ui_modal = (modal, item) => {
    // console.log("handle_show_ui_modal");
    switch (modal) {
      case "download_all":
        this.api_downloadfile_items();
        break;
      case "download_small":
        this.api_downloadfile_small_items();
        break;
      default:
    }
  };

  //////////
  render() {
    const {
      planAcademicYear,
      data,
      loading,
      totalTarget,
      totalPlan,
      totalConfident,
    } = this.state;
    const columns = [
      {
        title: "計畫學年",
        align: "center",
        responsive: ["lg"],
        dataIndex: "PlanAcademicYear",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學院",
        dataIndex: "CollegeShortName",
        responsive: ["lg"],
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學制",
        align: "center",
        dataIndex: "EducationalSystemTwName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "系所",
        dataIndex: "DeptmentShortName",
        align: "center",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          <>
            甄選入學<br></br>一般生(A1)
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "A1TargetTotal",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 700, color: "#A9A9AF" },
            },
            children: <div>{text === 0 ? "" : text}</div>,
          };
        },
      },
      {
        title: (
          <>
            聯登招生<br></br>(A2)
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "A2TargetTotal",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 700, color: "#A9A9AF" },
            },
            children: <div>{text === 0 ? "" : text}</div>,
          };
        },
      },
      {
        title: (
          <>
            藝術單招<br></br>(B1)
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "BATargetTotal",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 700, color: "#A9A9AF" },
            },
            children: <div>{text === 0 ? "" : text}</div>,
          };
        },
      },
      {
        title: (
          <>
            特殊選才<br></br>(B2)
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "BBTargetTotal",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 700, color: "#A9A9AF" },
            },
            children: <div>{text === 0 ? "" : text}</div>,
          };
        },
      },
      {
        title: (
          <>
            繁星入學<br></br>(B3)
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "BCTargetTotal",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 700, color: "#A9A9AF" },
            },
            children: <div>{text === 0 ? "" : text}</div>,
          };
        },
      },
      {
        title: (
          <>
            運優單招<br></br>(B4)
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "BDTargetTotal",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 700, color: "#A9A9AF" },
            },
            children: <div>{text === 0 ? "" : text}</div>,
          };
        },
      },
      {
        title: (
          <>
            一般獨招<br></br>(B5)
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "BETargetTotal",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 700, color: "#A9A9AF" },
            },
            children: <div>{text === 0 ? "" : text}</div>,
          };
        },
      },
      {
        title: (
          <>
            四技申請<br></br>高中生(C)
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "CATargetTotal",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 700, color: "#A9A9AF" },
            },
            children: <div>{text === 0 ? "" : text}</div>,
          };
        },
      },
      {
        title: "計畫學年核定招生名額",
        width: 180,
        children: [
          {
            title: (
              <>
                技高<br></br>(A+B)
              </>
            ),
            dataIndex: "PlanVocationalApprovedTotal",
            align: "center",
            responsive: ["lg"],
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 700, color: "#A9A9AF" },
                },
                children: (
                  <div>
                    {record.DeptmentRealCode === "196"
                      ? "*" + text
                      : record.DeptmentRealCode === "165"
                      ? "*" + text
                      : record.DeptmentRealCode === "0"
                      ? ""
                      : text}
                  </div>
                ),
              };
            },
          },
          {
            title: (
              <>
                高中<br></br>(C)
              </>
            ),
            dataIndex: "PlanNormalApprovedTotal",
            align: "center",
            responsive: ["lg"],
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 700, color: "#A9A9AF" },
                },
                children: <div>{text === 0 ? "" : text}</div>,
              };
            },
          },
          {
            title: "合計",
            dataIndex: "PlanALLApprovedTotal",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              switch (record.CollegeCode) {
                case "60": // 民生暨管理學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: { fontWeight: 900, color: textColor },
                },
                children: <div>{text === 0 ? "" : text}人</div>,
              };
            },
          },
        ],
      },
      {
        title: (
          <>
            技優甄選<br></br>(D)
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "DATargetTotal",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 700, color: "#A9A9AF" },
            },
            children: <div>{text === 0 ? "" : text}</div>,
          };
        },
      },
      {
        title: (
          <>
            規劃年度<br></br>來源校數
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "SourceSchoolTotal",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                fontWeight: 900,
                color: textColor,
              },
            },
            children: <div>{text}所</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>規劃人數
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "PlanQuotaTotal",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                fontWeight: 900,
                color: textColor,
              },
            },
            children: <div>{text}人</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>規劃率
          </>
        ),
        align: "center",
        dataIndex: "PlanQuotaRatio",
        render(text, record) {
          return {
            props: {
              style: {
                fontWeight: 900,
                background:
                  text < 110 ? "#FAC4BB" : text > 115 ? "#83eef7" : "#D1FABB",
              },
            },
            children: <div>{text}%</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>預收達成人數
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "ConfidentQuotaTotal",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                fontWeight: 900,
                color: textColor,
              },
            },
            children: <div>{text}人</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>預達率
          </>
        ),
        align: "center",
        dataIndex: "ConfidentQuotaRatio",
        render(text, record) {
          return {
            props: {
              style: {
                fontWeight: 900,
                background: text >= 80 ? "#D1FABB" : "#FAC4BB",
              },
            },
            children: <div>{text}%</div>,
          };
        },
      },
    ];

    return (
      <>
        <Input
          placeholder="規劃年度"
          style={{
            width: 55,
            height: 39,
            margin: "0 5px",
            color: "red",
          }}
          onChange={(event) =>
            this.setState({ planAcademicYear: event.target.value })
          }
          value={planAcademicYear}
          readOnly={true}
          disabled={true}
        />
        <button
          className="btn btn-info"
          onClick={this.handle_data_refresh}
          style={{
            marginLeft: "2px",
            marginBottom: "4px",
            display: "inline-block",
          }}
        >
          <i className="fas fa-sync-alt"></i>
        </button>
        <button
          className="btn btn-info"
          onClick={() => this.handle_show_ui_modal("download_all", {})}
          style={{ marginLeft: "2px", marginBottom: "4px" }}
        >
          <i className="fas fa-cloud-download-alt"></i>
        </button>
        <button
          className="btn btn-info"
          onClick={() => this.handle_show_ui_modal("download_small", {})}
          style={{ marginLeft: "2px", marginBottom: "4px" }}
        >
          <i className="fas fa-download"></i>
        </button>
        <Alert
          message={
            totalTarget > 0 ? (
              <>
                <span style={{ color: "orange", fontWeight: 900 }}>
                  教育部核定人數：{totalTarget}人
                </span>{" "}
                |{" "}
                <span style={{ color: "blue", fontWeight: 900 }}>
                  當前規劃人數： {totalPlan}人
                </span>{" "}
                |{" "}
                <span style={{ color: "green", fontWeight: 900 }}>
                  預收達成人數： {totalConfident}人
                </span>{" "}
              </>
            ) : (
              <></>
            )
          }
          type="error"
        />
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <p></p>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SchoolPlanTargetGoal);
